<template>
  <div class="app flex-row align-items-center" id="registerSafePlaceUser-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3">
          <Header></Header>
        </b-col>
        <b-col class="mt-5" md="8" sm="8">
          <b-form>
            <div class="card" style="border-radius: 11px;">
              <div class="card-header">
                <p style="font-weight: bold">
                  REVIEW INFORMATION
                </p>
              </div>
              <div class="card-body">
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertSuccess = false
                  "
                  >{{ mData.dataDefault.success }}</b-alert
                >

                <div class="infomation">
                  <el-collapse v-model="mData.dataDefault.activeName">
                    <el-collapse-item title="Passport information" name="1">
                      <el-form label-position="top">
                        <div class="row">
                          <!-- <div class="col-md-3 col-12">
                            <el-form-item label="Type">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu.loai
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div> -->
                          <div class="col-md-4 col-12">
                            <el-form-item label="Code">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu.ma_so
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-md-8 col-12">
                            <el-form-item label="Passport No.">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .so_ho_chieu
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-12">
                            <el-form-item label="Fullname">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu.ho_ten
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-md-6 col-12">
                            <el-form-item label="Nationality">
                              <el-select
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .quoc_tich_id
                                "
                                disabled
                              >
                                <el-option
                                  v-for="item in mData.dataDefault
                                    .nationalityList"
                                  :key="item.id"
                                  :label="
                                    item.ten_quoc_tich && item.ten_quoc_tich.en
                                      ? item.ten_quoc_tich.en
                                      : ''
                                  "
                                  :value="item.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div class="col-md-6 col-12">
                            <el-form-item label="Date of birth">
                              <el-date-picker
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .ngay_sinh
                                "
                                type="date"
                                disabled
                                :format="aElement.datepicker.formatDate"
                                :valueFormat="aElement.datepicker.valueFormat"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <!-- <div class="col-12">
                            <el-form-item label="Place of birth">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .noi_sinh
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div> -->
                          <div class="col-md-6 col-12">
                            <el-form-item label="Sex">
                              <el-radio
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .gioi_tinh
                                "
                                :label="1"
                                disabled
                                class="mr-2"
                                >Male</el-radio
                              >
                              <el-radio
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .gioi_tinh
                                "
                                :label="2"
                                disabled
                                class="mr-2"
                                >Female</el-radio
                              >
                              <el-radio
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .gioi_tinh
                                "
                                :label="4"
                                disabled
                                class="mr-2"
                                >Other</el-radio
                              >
                            </el-form-item>
                          </div>
                          <!-- <div class="col-md-6 col-12">
                            <el-form-item label="Id card No.">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu.cmnd
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="col-md-6 col-12">
                            <el-form-item label="Date of issue">
                              <el-date-picker
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .ngay_cap
                                "
                                type="date"
                                disabled
                                :format="aElement.datepicker.formatDate"
                                :valueFormat="aElement.datepicker.valueFormat"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </div> -->
                          <div class="col-md-6 col-12">
                            <el-form-item label="Date of expiry">
                              <el-date-picker
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .hieu_luc_den
                                "
                                type="date"
                                disabled
                                :format="aElement.datepicker.formatDate"
                                :valueFormat="aElement.datepicker.valueFormat"
                              >
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <!-- <div class="col-12">
                            <el-form-item label="Place of issue">
                              <el-input
                                v-model="
                                  mData.dataDefault.dataPassport.ho_chieu
                                    .noi_cap
                                "
                                disabled
                              ></el-input>
                            </el-form-item>
                          </div> -->
                          <div class="col-12">
                            <el-form-item label="Passport photo">
                              <div class="box-image">
                                <el-image
                                  :src="this.mData.dataDefault.anhPassport"
                                  lazy
                                ></el-image>
                              </div>
                            </el-form-item>
                          </div>
                          <div class="col-12">
                            <el-form-item label="Selfie photo">
                              <div class="box-image">
                                <el-image
                                  :src="this.mData.dataDefault.anhSelfie"
                                  lazy
                                ></el-image>
                              </div>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </el-collapse-item>
                  </el-collapse>
                </div>

                <el-form
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                  class="mt-3"
                >
                  
                  <el-form-item>
                    <div class="btn-group">
                      <el-button 
                        class="btn-back"
                        @click="fn_go()" 
                        type="info" 
                        plain
                      >BACK</el-button>
                      <el-button
                        type="primary"
                        class="btn-next"
                        @click="fn_submitForm()"
                        v-ladda
                        native-type="submit"
                        >Next</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div class="card-footer">
              </div>
            </div>
                
          </b-form>
        </b-col>
        <b-col md="12" class="text-center mt-3">
          <Footer></Footer>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import MethodService from "../../service/MethodService";
import QuocGiaApi from "../../moduleApi/QuocGiaApi";
import ForeignApi from "../../moduleApi/ForeignerApi";
import AuthService from "../../service/AuthService";
import Header from "../../containers/HeaderRegister";
import Footer from "../../containers/FooterRegister";
// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19' });

let firstProvince = {
  id: "",
  type: "",
  name: "Chọn tỉnh/thành phố",
  code: "",
};
let firstDistrict = {
  id: "",
  type: "",
  name: "Chọn quận/huyện",
  code: "",
};
let firstCommune = {
  id: "",
  type: "",
  name: "Chọn phường/xã",
  code: "",
};

export default {
  components: {
    Header,
    Footer
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter a value!"));
      } else if (value !== this.mData.dataForm.password) {
        callback(new Error("Password don't match!"));
      } else {
        callback();
      }
    };
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          nationalityList: [],
          activeName: "1",
          dataPassport: {
            anh_chan_dung_id: null,
            ho_chieu: {
              loai: "",
              ma_so: "",
              ho_ten: "",
              quoc_tich_id: "",
              ngay_sinh: null,
              so_ho_chieu: "",
              noi_sinh: "",
              gioi_tinh: null,
              cmnd: "",
              ngay_cap: null,
              hieu_luc_den: null,
              noi_cap: "",
            },
          },
          anhSelfie: "",
          anhPassport: "",
        },
        dataForm: {
          email: "",
          password: "",
          repassword: "",
        },
        validForm: {
        },
      },
    };
  },
  methods: {
    fn_submitForm() {
        let data = {
          dataPassport: this.mData.dataDefault.dataPassport
        };
        sessionStorage.setItem("foreignRegister", JSON.stringify(data));
        this.$router.push("/auth/travelpass-register/declaration");
    },
    async getNationalityList() {
      const nationality = await QuocGiaApi.list();
      this.mData.dataDefault.nationalityList = nationality.result;
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    async fn_initData() {
      await this.getNationalityList();
      let data = sessionStorage.getItem("foreignRegister")
        ? JSON.parse(sessionStorage.getItem("foreignRegister"))
        : {};
        console.log("data cònirm",data);
      if (data && data.ho_chieu && data.anh_chan_dung_id) {
        this.mData.dataDefault.dataPassport = data;
        this.mData.dataDefault.anhSelfie =
          window.MyConfig.hostApi + "file/thumb?id=" + data.anh_chan_dung_id;
        this.mData.dataDefault.anhPassport =
          data.ho_chieu && data.ho_chieu.anh_id
            ? window.MyConfig.hostApi + "file/thumb?id=" + data.ho_chieu.anh_id
            : "";
      } else if (data && data.dataPassport && data.dataPassport.ho_chieu && data.dataPassport.anh_chan_dung_id) {
        this.mData.dataDefault.dataPassport = data.dataPassport;
        this.mData.dataDefault.anhSelfie =
          window.MyConfig.hostApi + "file/thumb?id=" + data.dataPassport.anh_chan_dung_id;
        this.mData.dataDefault.anhPassport =
          data.dataPassport.ho_chieu && data.dataPassport.ho_chieu.anh_id
            ? window.MyConfig.hostApi + "file/thumb?id=" + data.dataPassport.ho_chieu.anh_id
            : "";
            // console.log("this.mData.dataDefault.dataPassport",this.mData.dataDefault.dataPassport);
      } else {
        sessionStorage.removeItem("foreignRegister");
        this.$router.push("/auth/travelpass-register/passport");
      }
    },
    fn_go() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.fn_initData();
  },
  created() {},
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
#registerSafePlaceUser-page {
  background-color: #e8eef2;
  background-attachment: fixed;
  background-position: top center;
}
.box-image{
  max-width: 500px;
  text-align: center;
}
.box-image-passport{
  max-width: 340px;
}
.box-image-selfie{
  max-width: 150px;
}
.card{
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;
}
.card-header{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 55px;
  background-color: #0c66ad;
  border-color: #0c66ad;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-header p{
  margin-bottom: 0 !important;
  color: #ffffff;
  font-size: 20px;
}
.card-body{
  padding: 20px 20px 0 20px;
}
.card-footer{
  background-color: #0c66ad;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 10px;
  padding: 0;
}
.btn-group{
  padding: 0 50px 0 50px;
  display: flex;
  justify-content: space-between;
}
.btn-group .btn-back{
  background-color: #ade0eb;
  border-color: #ade0eb;
  color: #0c66ad;
  font-weight: 700;
}
.btn-group .btn-back:hover{
  border-color: #ade0eb;
}
.btn-group .btn-next{
  background-color: #0c66ad;
  border-color: #0c66ad;
}
.btn-group .btn-next:hover{
  border-color: #0c66ad;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
::v-deep .el-collapse-item__header{
  color: #0c66ad;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
::v-deep .el-form-item__label{
  color: #0c66ad;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
::v-deep .el-button.is-disabled:hover{
  cursor: not-allowed;
}
::v-deep .el-upload {
  display: block;
  margin-bottom: 15px;
}
.email-notice {
  line-height: 18px;
  padding-top: 10px;
  font-size: 11px;
}

@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  .text {
    font-size: 12px;
  }
}
</style>